import React, { useEffect, useState } from "react";
import firstimg from "../../../img/warning.png";
import { ImCross } from "react-icons/im";
import NavHear from "./NavHear";
import Footer from "./TestFooter/Footer";
import { Link, useNavigate } from "react-router-dom";
import "./heartest.css";
import { useDispatch } from "react-redux";
import { submitTest, hearingpdf } from "../../../Helper/Redux/API";
import { toast } from "react-toastify";

function Warning() {
  const navigate = useNavigate();

  const [answerArray, setAnswerArray] = useState([]);
  const [questionArray, setQuestionArray] = useState([]);
  const [testid, setTestId] = useState("");
  const audioArray = [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1];

  useEffect(() => {
    setAnswerArray([
      JSON.parse(localStorage.getItem("step2"))?.answer_id,
      JSON.parse(localStorage.getItem("step3"))?.answer_id,
      JSON.parse(localStorage.getItem("step4"))?.answer_id,
      JSON.parse(localStorage.getItem("step5"))?.answer_id,
      JSON.parse(localStorage.getItem("step6"))?.answer_id,
      JSON.parse(localStorage.getItem("step7"))?.answer_id,
      JSON.parse(localStorage.getItem("step8"))?.answer_id,
      JSON.parse(localStorage.getItem("Rightear2KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Rightear4KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear6KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear1KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Rightear500Hz"))?.question_id,
      JSON.parse(localStorage.getItem("rightear1KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear500Hz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear2000KHz"))?.question_id,
    ]);
    setQuestionArray([
      JSON.parse(localStorage.getItem("step2"))?.question_id,
      JSON.parse(localStorage.getItem("step3"))?.question_id,
      JSON.parse(localStorage.getItem("step4"))?.question_id,
      JSON.parse(localStorage.getItem("step5"))?.question_id,
      JSON.parse(localStorage.getItem("step6"))?.question_id,
      JSON.parse(localStorage.getItem("step7"))?.question_id,
      JSON.parse(localStorage.getItem("step8"))?.question_id,
      JSON.parse(localStorage.getItem("Rightear2KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Rightear4KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear6KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear1KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Rightear500Hz"))?.question_id,
      JSON.parse(localStorage.getItem("rightear1KHz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear500Hz"))?.question_id,
      JSON.parse(localStorage.getItem("Leftear2000KHz"))?.question_id,
    ]);
  }, [localStorage]);

  const disptach = useDispatch();
  const handleSubmit = () => {
    const requestOption = {
      option_id: answerArray,
      question_id: questionArray,
      is_audio: audioArray,
    };
    disptach(submitTest(requestOption)).then((res) => {
      if (res?.payload?.status === false) {
        toast.error(res?.payload?.message);
      } else {
        toast.success(res?.payload?.message);
        // console.log("dfdff", res);
        // let testcheck = res?.payload.is_test;
        navigate("/hearingtest/result-full");
        setTestId(res?.payload.test_id);
        // localStorage.setItem("testtrue", testcheck);
        localStorage.setItem("result_test_id", res?.payload.test_id);
        const hearingpdfdata = {
          test_id: res?.payload.test_id,
        };

        disptach(hearingpdf(hearingpdfdata)).then((res) => {
          if (res?.payload?.status === false) {
            toast.error(res?.payload?.message);
          } else {
            // toast.success(res?.payload?.message);
            // console.log("dfdfddsdsdsdsds", res);
          }
        });
      }
    });
  };

  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            {/* container start */}
            <section className="step_1 step2 warning  wow  fadeInUp animated">
              <Link to="/hearingtest/measurement/left-4000">
                {" "}
                <button className="cross_btn_warning">
                  <ImCross />
                </button>
              </Link>

              <div className="warning_outer">
                <div className="waring_div">
                  <img src={firstimg} alt="" />
                  <h1>Safety warning</h1>

                  <p>
                    {" "}
                    Before the test started, you were asked to set your device
                    volume to 100%. Please lower your device volume back to its
                    original setting now that the test has ended.
                  </p>

                  <div>
                    <button
                      onClick={() => handleSubmit()}
                      className="submit_btn"
                    >
                      Show Result
                    </button>
                  </div>
                </div>
              </div>
            </section>
            {/* container end */}
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Warning;
